// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-details-container {
    font-family: Arial, sans-serif;
    padding: 20px;
    margin-left: 50px;
    margin-right: 50px;
    max-width: 1200px;
    margin: auto;
}

.order-details-container h2, h3 {
    margin-bottom: 10px;
}

.order-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
}

.order-table th, .order-table td {
    border: 1px solid #ddd;
    padding: 10px;
    text-align: left;
}

.order-table th {
    background-color: #f4f4f4;
}

.notice {
    color: #e44d26;
    font-weight: bold;
    margin-bottom: 10px;
}

.bank-list {
    margin-bottom: 20px;
}

.bank-card {
    border: 1px solid #ddd;
    margin-top: 20px;
    padding: 10px;
    width: 90%;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.bank-card h4 {
    margin-top: 0;
    color: #007bff;
}

.bank-card p {
    margin: 5px 0;
}

.qr-button {
    margin-top: 10px;
    padding: 8px 15px;
    background-color: #007bff;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 4px;
}

.qr-button:hover {
    background-color: #0056b3;
}

.summary {
    padding: 15px;
    border: 1px solid #f4f4f4;
    background-color: #fff7e6;
    margin-bottom: 20px;
    width: 250px;
    float: left;
}

.summary p {
    margin: 5px 0;
}

.summary h6 {
    margin-top: 0;
    color: #e44d26;
}

.buttons {
   
}

.service-btn, .track-btn {
    padding: 10px 20px;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    font-size: 14px;
}

.service-btn {
    background-color: #007bff;
    color: white;
}

.service-btn:hover {
    background-color: #0056b3;
}

.track-btn {
    background-color: #f4f4f4;
    color: #333;
}

.track-btn:hover {
    background-color: #e4e4e4;
}
.qr-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
}

.qr-content {
    background: #fff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
    text-align: center;
}

.qr-content img {
    max-width: 300px;
    max-height: 300px;
}

.message-notify {
    padding: 20px;
    border: 1px solid #bfdefc;
    background-color: #d7eafd;
}
.message-notify .message-thanks>.d-inline-flex .icon-thumbs {
    padding: 16px 20px;
    background-color: #62aef7;
    margin-right: 15px;
}
.message-notify .message-thanks>.d-inline-flex .icon-thumbs {
    padding: 16px 20px;
    background-color: #62aef7;
    margin-right: 15px;
}
.mb-20px {
    margin-bottom: 20px !important;
}
.mt-15px {
    margin-top: 15px !important;
}
.text-justify
{
    
}
li {
    display: list-item;
    text-align: -webkit-match-parent;
    unicode-bidi: isolate;
}
.divbank
{
    margin-top: 50px;
}`, "",{"version":3,"sources":["webpack://./src/pages/PaymentMethods/PaymentBank.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;;AAEA;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,2BAA2B;AAC/B;AACA;;;AAGA;AACA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,qBAAqB;AACzB;AACA;;IAEI,gBAAgB;AACpB","sourcesContent":[".order-details-container {\n    font-family: Arial, sans-serif;\n    padding: 20px;\n    margin-left: 50px;\n    margin-right: 50px;\n    max-width: 1200px;\n    margin: auto;\n}\n\n.order-details-container h2, h3 {\n    margin-bottom: 10px;\n}\n\n.order-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 20px;\n}\n\n.order-table th, .order-table td {\n    border: 1px solid #ddd;\n    padding: 10px;\n    text-align: left;\n}\n\n.order-table th {\n    background-color: #f4f4f4;\n}\n\n.notice {\n    color: #e44d26;\n    font-weight: bold;\n    margin-bottom: 10px;\n}\n\n.bank-list {\n    margin-bottom: 20px;\n}\n\n.bank-card {\n    border: 1px solid #ddd;\n    margin-top: 20px;\n    padding: 10px;\n    width: 90%;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.bank-card h4 {\n    margin-top: 0;\n    color: #007bff;\n}\n\n.bank-card p {\n    margin: 5px 0;\n}\n\n.qr-button {\n    margin-top: 10px;\n    padding: 8px 15px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    cursor: pointer;\n    border-radius: 4px;\n}\n\n.qr-button:hover {\n    background-color: #0056b3;\n}\n\n.summary {\n    padding: 15px;\n    border: 1px solid #f4f4f4;\n    background-color: #fff7e6;\n    margin-bottom: 20px;\n    width: 250px;\n    float: left;\n}\n\n.summary p {\n    margin: 5px 0;\n}\n\n.summary h6 {\n    margin-top: 0;\n    color: #e44d26;\n}\n\n.buttons {\n   \n}\n\n.service-btn, .track-btn {\n    padding: 10px 20px;\n    border: none;\n    cursor: pointer;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n.service-btn {\n    background-color: #007bff;\n    color: white;\n}\n\n.service-btn:hover {\n    background-color: #0056b3;\n}\n\n.track-btn {\n    background-color: #f4f4f4;\n    color: #333;\n}\n\n.track-btn:hover {\n    background-color: #e4e4e4;\n}\n.qr-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.qr-content {\n    background: #fff;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n    text-align: center;\n}\n\n.qr-content img {\n    max-width: 300px;\n    max-height: 300px;\n}\n\n.message-notify {\n    padding: 20px;\n    border: 1px solid #bfdefc;\n    background-color: #d7eafd;\n}\n.message-notify .message-thanks>.d-inline-flex .icon-thumbs {\n    padding: 16px 20px;\n    background-color: #62aef7;\n    margin-right: 15px;\n}\n.message-notify .message-thanks>.d-inline-flex .icon-thumbs {\n    padding: 16px 20px;\n    background-color: #62aef7;\n    margin-right: 15px;\n}\n.mb-20px {\n    margin-bottom: 20px !important;\n}\n.mt-15px {\n    margin-top: 15px !important;\n}\n.text-justify\n{\n    \n}\nli {\n    display: list-item;\n    text-align: -webkit-match-parent;\n    unicode-bidi: isolate;\n}\n.divbank\n{\n    margin-top: 50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
